import PropTypes from "prop-types";
import React, { useState } from "react";
import { MdOutlineClose as MdOutlineCloseIcon } from "react-icons/md";
import { ReactComponent as ArrowReverseIcon } from "../../../../../assets/images/chat/arrow-reverse-icon.svg";
import { ReactComponent as ArrowIcon } from "../../../../../assets/images/habitacional/arrow-icon.svg";
import * as S from "./SideBar.style";
import { menuLinks } from "../Constants/ConstantsMenuList";

const Sidebar = ({ isOpenMenu, onToggle }) => {
  const [isOpenSubmenu, setIsOpenSubmenu] = useState(false);
  const [currentSubmenu, setCurrentSubmenu] = useState(null);

  const handleToggleSubmenu = (currentSubmenuParam, event) => {
    event?.preventDefault();

    setCurrentSubmenu(currentSubmenuParam);
    setIsOpenSubmenu((state) => !state);
  };

  const handleCloseAllSidebar = () => {
    onToggle();
    setIsOpenSubmenu(false);
  };

  const handleClickLink = (event, sidebarLink) => {
    if (Array?.isArray(sidebarLink?.submenu)) {
      handleToggleSubmenu(sidebarLink, event);
      return;
    }

    onToggle();
  };

  return (
    <>
      <S.Overlay isOpen={isOpenMenu} onClick={handleCloseAllSidebar} />
      <S.SidebarContainer isOpen={isOpenMenu}>
        <S.SidebarHeader>
          <div>Menu</div>
          <MdOutlineCloseIcon onClick={onToggle} />
        </S.SidebarHeader>

        <nav>
          <S.SidebarLinksList>
            {menuLinks.map((sidebarLink) => {
              const target = sidebarLink.isExternalLink ? "_blank" : "_self";

              return (
                <li key={`${sidebarLink.label}-mobile`}>
                  <a
                    target={target}
                    href={sidebarLink.href}
                    onClick={(event) => handleClickLink(event, sidebarLink)}
                  >
                    {sidebarLink.label}

                    {Array.isArray(sidebarLink.submenu) && (
                      <ArrowIcon width="28px" height="28px" />
                    )}
                  </a>
                </li>
              );
            })}
          </S.SidebarLinksList>
        </nav>
      </S.SidebarContainer>

      {/* Submenu */}
      <S.SidebarContainer isOpen={isOpenSubmenu}>
        <S.SidebarHeader>
          <div>
            <ArrowReverseIcon onClick={handleToggleSubmenu} />
            {currentSubmenu?.label}
          </div>
          <MdOutlineCloseIcon onClick={handleToggleSubmenu} />
        </S.SidebarHeader>

        <nav>
          <S.SidebarLinksList>
            {Array.isArray(currentSubmenu?.submenu) &&
              currentSubmenu?.submenu
                .filter((sidebarLink) => !sidebarLink.isDivider)
                .map((sidebarLink, submenuIndex) => {
                  return (
                    <li key={`${sidebarLink.label}-${submenuIndex}-mobile`}>
                      <a href={sidebarLink.href}>
                        {sidebarLink.label}

                        {Array.isArray(sidebarLink.submenu) && (
                          <ArrowIcon width="28px" height="28px" />
                        )}
                      </a>
                    </li>
                  );
                })}
          </S.SidebarLinksList>
        </nav>
      </S.SidebarContainer>
    </>
  );
};

export default Sidebar;

Sidebar.propTypes = {
  isOpenMenu: PropTypes.bool,
  onToggle: PropTypes.func,
};

Sidebar.defaultProps = {
  isOpenMenu: false,
  onToggle: null,
};
